'use client'

import { useEffect, useState } from 'react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'

import { ONE } from 'config/apis'
import { getRequest } from 'services/private'
import { useMainContext } from 'utils/context'
import TableStaticPagination from 'components/TableStaticPagination'
import Spin from 'components/Spin'
import NoResults from 'components/NoResults'
import { useLeagueContext } from 'utils/context'
import HeaderClub from 'components/privat/HeaderClub'
import { GoBackAction } from 'components/GoBack'
import AlertPending from 'components/AlertPending'
import AlertNotices from 'components/AlertNotices'
import HeaderCaptain from 'components/privat/HeaderCaptain'

const TorMatches = ({ user, showClubFromPrivate, setShowClubFromPrivate }) => {
  const {
    showClub,
    setShowClub,
    divisionFilterSelected,
    // dayFilterSelected,
    // setHideDayFilter = () => {},
    categoryFilterSelected
  } = useLeagueContext() || {}

  const { fedId, fedToken, clubId, clubToken } = useMainContext()
  const [loading, setLoading] = useState()
  const [classification, setClassification] = useState([])
  const [classificationType, setClassificationType] = useState()
  const [teamId, setTeamId] = useState()
  const [teamData, setTeamData] = useState()
  const [teamClassification, setTeamClassification] = useState()
  const [colorColumnTable, setColorColumnTable] = useState({})
  const [colorColumnReference, setColorColumnReference] = useState([])
  const [classificationNote, setClassificationNote] = useState('')

  const getPageData = async () => {
    setLoading(true)
    const pageDataReq = await getRequest({
      user: user || divisionFilterSelected || clubId,
      token: fedToken || clubToken,
      endpoint: 'LEAGUES_CLASSIFICATION'
    })
    setClassification(pageDataReq.Results)
    setClassificationType(pageDataReq.Type)
    setColorColumnTable(pageDataReq.DetailColumnsClassification)
    setColorColumnReference(pageDataReq.MasterColumnsClassification)
    setClassificationNote(pageDataReq.WebObservations)
    setLoading(false)
  }
  useEffect(() => {
    if (user || divisionFilterSelected) {
      getPageData()
    }
  }, [user, divisionFilterSelected])

  useEffect(() => {
    setClassification([])
  }, [categoryFilterSelected])

  const getTeam = async (id) => {
    setLoading(true)
    let pageDataReq
    let pageData
    if (user || clubId) {
      const qs = `${user ? `?license=${fedId}` : `?clubId=${clubId}`}`
      pageDataReq = await getRequest({
        user: id,
        token: fedToken || clubToken,
        endpoint: 'LEAGUES_TEAM',
        queryString: qs
      })
      pageData = pageDataReq
    } else {
      pageDataReq = await fetch(ONE.LEAGUES_TEAM.replace('{id}', id), {
        ...ONE.HEADERS,
        next: { revalidate: 60 * 10 }
      })
      pageData = (await pageDataReq.json()).Data
    }

    setTeamData(pageData.BasicData)
    // setTeamClassification(
    //   pageData.Sex.find(({ SexId }) => SexId === 'FEMENINO').AgeCategories[0]
    //     .Players
    // )
    setTeamClassification(pageData.Sex[0].AgeCategories[0].Players)
    setLoading(false)
  }

  // useEffect(() => {
  //   setHideDayFilter(true)
  // }, [])

  return loading ? (
    <div className="flex justify-center my-20">
      <Spin color="text-blue" size="10" className="my-2 lg:my-8" />
    </div>
  ) : (
    <>
      {(showClub && teamData && teamClassification) || showClubFromPrivate ? (
        <>
          <div className="max-w-6xl mx-auto py-10">
            <GoBackAction
              action={() => {
                if (user) {
                  setShowClubFromPrivate(false)
                } else {
                  setShowClub(false)
                }
                setTeamData()
              }}
            />
          </div>
          <HeaderClub
            name={teamData.Name}
            place={teamData.GamingVenue}
            address={teamData.Address}
            img={teamData.Image1}
            openHours={teamData.Schedule}
            weekday={teamData.GamesDay}
            courts={teamData.CourtNumbers}
            captain={teamData.CaptainName}
            subcaptain={teamData.SubCaptainName}
          />
          {user || clubId ? (
            <div className="mt-2 lg:mt-8">
              <HeaderCaptain
                captainImg={teamData.CaptainImg}
                captainName={teamData.CaptainName}
                captainEmail={teamData.CaptainEmail}
                captainPhone={teamData.CaptainPhone}
                subCaptainImg={teamData.SubCaptainImg}
                subCaptainName={teamData.SubCaptainName}
                subCaptainEmail={teamData.SubCaptainEmail}
                subCaptainPhone={teamData.SubCaptainPhone}
              />
            </div>
          ) : null}
          <div className="max-w-4xl mx-auto">
            <div className="mt-8 mb-40">
              <TableStaticPagination
                headers={[
                  'Nº',
                  'Llicència',
                  'Jugador',
                  '',
                  // 'Data naixement',
                  'Punts'
                ]}
                content={teamClassification.map((player) => {
                  return {
                    0: player.PositionNumber,
                    1: player.License,
                    2: player.Name,
                    // 3: dateToString(player.BirthDate).withYear,
                    3: player.Points
                  }
                })}
                cols={5}
                extraClass={{
                  2: 'col-span-2'
                }}
                resultsByPage={50}
              />
            </div>
          </div>
        </>
      ) : null}
      {!showClub && !showClubFromPrivate && (
        <div
          className={`max-w-6xl mb-40 ${user ? 'mx-3 lg:mx-10' : 'mx-auto'}`}
        >
          {classification && !classification.length ? (
            <NoResults />
          ) : (
            <TableStaticPagination
              headers={
                classificationType === 'Normal'
                  ? [
                      '',
                      'EQUIP',
                      '',
                      '',
                      'PUNTS',
                      'J',
                      // 'G',
                      // 'P',
                      'DS',
                      'DJ',
                      'SANCIÓ',
                      'WO',
                      <ExclamationTriangleIcon className="h-6 w-6" />
                    ]
                  : [
                      '',
                      '',
                      'EQUIP',
                      '',
                      'PUNTS',
                      'J',
                      'G',
                      'P',
                      // 'PF',
                      // 'PC',
                      // 'SF',
                      // 'SC',
                      'PUNTS VERMELLS'
                    ]
              }
              content={classification?.map((team) =>
                classificationType === 'Normal'
                  ? {
                      0: 'color',
                      1: team.PositionNumber,
                      2: team.Name,
                      3: team.Points,
                      4: team.MatchesPlayed,
                      // 5: team.MatchesWon,
                      // 6: team.MatchesLost,
                      5: team.SetWon - team.SetLost,
                      6: (team?.GamesWon ?? 0) - (team?.GamesLost ?? 0),
                      7: team.Sanctions,
                      8: team.Wo,
                      9: team.Warnings,
                      10: `id:${team.IdTeam}`
                    }
                  : {
                      0: 'color',
                      1: team.PositionNumber,
                      2: team.Name,
                      3: team.Points,
                      4: team.MatchesPlayed,
                      5: team.MatchesWon,
                      6: team.MatchesLost,
                      // 6: team.SubMatchesWon,
                      // 7: team.SubMatchesLost,
                      // 8: team.SetWon,
                      // 9: team.SetLost,
                      7: `circle:${team.RedPoints}`,
                      8: `id:${team.IdTeam}`
                    }
              )}
              cols={classificationType === 'Normal' ? 11 : 10}
              extraClass={{
                0: 'absolute left-0 h-full',
                1: 'text-center',
                2: 'col-span-3',
                3: 'font-bold'
              }}
              headersMobile={
                classificationType === 'Normal'
                  ? [
                      '',
                      '',
                      'EQUIP',
                      '',
                      '',
                      '',
                      'P',
                      'J',
                      // 'G',
                      'DS',
                      'DJ',
                      'S',
                      'W'
                    ]
                  : [
                      '',
                      '',
                      'EQUIP',
                      '',
                      '',
                      'P',
                      'J',
                      'G',
                      // 'DP',
                      // 'DS',
                      'PV'
                    ]
              }
              contentMobile={classification.map((team) =>
                classificationType === 'Normal'
                  ? {
                      0: 'color',
                      1: team.PositionNumber,
                      2: team.Name,
                      3: team.Points,
                      4: team.MatchesPlayed,
                      // 5: team.MatchesWon,
                      5: team.SetWon - team.SetLost,
                      6: team?.GamesWon - team?.GamesLost,
                      7: team.Sanctions,
                      8: team.Wo,
                      9: `id:${team.IdTeam}`
                    }
                  : {
                      0: 'color',
                      1: team.PositionNumber,
                      2: team.Name,
                      3: team.Points,
                      4: team.MatchesPlayed,
                      5: team.MatchesWon,
                      // 5: team.SetWon,
                      // 6: team.SetLost,
                      6: `circle:${team.RedPoints}`,
                      7: `id:${team.IdTeam}`
                    }
              )}
              colsMobile={classificationType === 'Normal' ? 11 : 9}
              extraClassHeaderMobile={{
                0: 'absolute left-0 h-full'
              }}
              extraClassMobile={{
                0: 'absolute left-0 h-full',
                2:
                  classificationType === 'Normal'
                    ? 'col-span-4 text-xs text-left'
                    : 'col-span-3 text-left'
              }}
              forceRowsInMobile={true}
              setOnClick={() => {
                const _teamId =
                  event.target.parentElement.childNodes[0].dataset?.id ||
                  event.target.parentElement.childNodes[0].childNodes[0].dataset
                    ?.id
                setTeamId(_teamId)
                getTeam(_teamId)
                if (user) {
                  setShowClubFromPrivate(true)
                } else {
                  setShowClub(true)
                }
              }}
              resultsByPage={50}
              additionalData={{
                ...colorColumnTable,
                pending: classification.map(
                  ({ PendingReview }) => PendingReview
                )
              }}
            />
          )}
          {classificationNote && (
            <p className="text-md text-sec-grey-50 -mt-4 lg:-mt-10">
              {classificationNote}
            </p>
          )}
          <p className="text-[18px] mt-8 mb-4">
            Els desempats a la classificació s’actualitzen cada dimecres
          </p>
          <div className="flex flex-wrap items-center gap-8">
            {colorColumnReference &&
              colorColumnReference.map((type, idx) => (
                <div
                  key={idx}
                  className="text-[15px] border-b-8 border-neutral-300"
                  style={{
                    borderColor: type.Color
                  }}
                >
                  {type.Name}
                </div>
              ))}
            <AlertPending />
            <AlertNotices />
          </div>
        </div>
      )}
    </>
  )
}

export default TorMatches
